import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
      fill: "#FF816B"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.7808 11.5505L12.877 20.7398C12.6745 21.7062 11.7312 22.3311 10.7591 22.1286C9.7927 21.926 9.16774 20.9828 9.37027 20.0107C9.41657 19.785 9.50915 19.5709 9.62489 19.3915L14.7808 11.5505Z",
      fill: "#FFEEEB",
      stroke: "#FFEEEB",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.3353 18.1704C17.7421 18.1704 20.5039 15.4087 20.5039 12.0018C20.5039 8.59503 17.7421 5.83325 14.3353 5.83325C10.9285 5.83325 8.16669 8.59503 8.16669 12.0018C8.16669 15.4087 10.9285 18.1704 14.3353 18.1704Z",
      fill: "#FF816B",
      stroke: "#FFEEEB",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.3353 16.8742C17.0262 16.8742 19.2077 14.6927 19.2077 12.0018C19.2077 9.31083 17.0262 7.12939 14.3353 7.12939C11.6443 7.12939 9.46289 9.31083 9.46289 12.0018C9.46289 14.6927 11.6443 16.8742 14.3353 16.8742Z",
      fill: "#FFEEEB"
    }, null, -1)
  ]))]))
}
export default { render: render }